module.exports = __webpack_public_path__ + "static/media/item-6.f62370a3.jpeg";